var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727273",
    d: "M34.789,25.406h2.167c-0.771-3.542-0.428-1.94-0.781-3.591C35.962,22.394,34.897,25.129,34.789,25.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727273",
    d: "M43,7H5c-2.206,0-4,1.794-4,4v26c0,2.206,1.794,4,4,4h38c2.206,0,4-1.794,4-4V11C47,8.794,45.206,7,43,7z  M12.942,28.792l-2.321-8.317c-0.802-0.445-1.718-0.803-2.742-1.05l0.033-0.199h4.209c0.567,0.021,1.025,0.202,1.183,0.808 l0.915,4.401l0.272,1.327l2.555-6.53h2.765l-4.109,9.558L12.942,28.792z M21.847,28.8h-2.609l1.632-9.576h2.61L21.847,28.8z  M26.389,28.942c-1.17-0.012-2.298-0.244-2.908-0.511l0.366-2.144c1.051,0.476,1.635,0.655,2.793,0.655 c0.75,0,1.555-0.293,1.562-0.935c0.005-0.419-0.337-0.719-1.353-1.188c-0.99-0.458-2.302-1.226-2.287-2.602 c0.015-1.861,1.832-3.16,4.411-3.16c1.012,0,1.822,0.208,2.339,0.402l-0.354,2.076c-0.677-0.32-1.351-0.49-2.188-0.477 c-1.022,0-1.495,0.426-1.495,0.824c-0.006,0.449,0.553,0.744,1.465,1.187c1.506,0.683,2.201,1.513,2.191,2.602 C30.914,27.658,29.133,28.942,26.389,28.942z M37.698,28.803c0,0-0.24-1.1-0.318-1.435c-0.381,0-3.043-0.004-3.343-0.004 c-0.101,0.259-0.55,1.439-0.55,1.439h-2.741l3.876-8.776c0.274-0.624,0.742-0.794,1.367-0.794h2.017l2.113,9.57H37.698z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaBw);
export default __webpack_public_path__ + "static/media/visa-bw.d2be45b349f7b9ef105cec572614450c.svg";
export { ForwardRef as ReactComponent };